export default __webpack_public_path__ + "static/media/home1-banner3.1ff3f1f2.jpg";